import React from 'react';
import {Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter} from '@chakra-ui/react';

/*
 * Takes in the three props from chakra-ui's useDisclosure hook.  Then takes in a title, body, and a function to perform if the user clicks yes.
 * @param {*} param0
 * @returns
 */
const ModalYesNo = ({isOpen, onOpen, onClose, title, body, yesFunction}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInBottom" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{body}</ModalBody>

          <ModalFooter>
            <Button colorScheme="secondary" variant="outline" mr={3} onClick={() => yesFunction()}>
              Yes
            </Button>
            <Button colorScheme="red" variant="outline" onClick={onClose}>
              No
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalYesNo;
